import { apis } from '@danckuts/api-js'
import userService from './userService'
import moment from 'moment'
import router from '@/router'
import { eraseCookie, getCookie, setCookie } from '@/framework/utilities/cookies.js'

const state = () => {
  return {
    accessToken: undefined,
    expires: undefined,
    userName: undefined,

    name: undefined,
    location: undefined,
    roles: undefined,

    isAdmin: false,
    isCheckIn: false,
    isDirector: false,
    isTech: false
  }
}

const getters = {
  getAccessToken: state => state.accessToken || getCookie('accessToken'),
  getExpires: state => state.expires || getCookie('expires'),
  getUserName: state => state.userName || getCookie('userName'),

  getName: state => state.name || getCookie('user_name'),
  getLocation: state => state.location || JSON.parse(getCookie('user_location')),
  getRoles: state => state.roles || getCookie('user_roles'),

  canAdmin: state => state.isAdmin || getCookie('isAdmin'),
  canCheckIn: state => (state.isAdmin || state.isDirector || state.isCheckIn) || (getCookie('isAdmin') || getCookie('isDirector') || getCookie('isCheckIn')), // TODO: Remove admin from this role. We do not want to have unauthorized users login including admins.
  canEmployee: state => (state.isAdmin || state.isDirector || state.isTech) || (getCookie('isAdmin') || getCookie('isDirector') || getCookie('isTech')),
  canTech: state => (state.isAdmin || state.isTech) || (getCookie('isAdmin') || getCookie('isTech')),

  defaultUserPath: state => {
    if (state.isCheckIn || state.isAdmin) {
      return '/check/in'
    } else if (state.isAdmin || state.isDirector) {
      return '/dashboard'
    } else if (state.isTech) {
      return '/tech'
    }
    return '/user'
  },

  hasLocation: state => !!state.location || !!getCookie('user_location'),
  isLoggedIn: state => !!state.accessToken || !!getCookie('accessToken')
}

const mutations = {
  logout: (state) => {
    // reset all values to default undefined user
    state.accessToken = undefined
    state.expires = undefined
    state.userName = undefined
    state.name = undefined
    state.location = undefined
    state.roles = undefined

    state.isAdmin = false
    state.isCheckIn = false
    state.isDirector = false
    state.isTech = false

    eraseCookie('accessToken')
    eraseCookie('expires')
    eraseCookie('userName')
    eraseCookie('user_name')
    eraseCookie('user_location')
    eraseCookie('isAdmin')
    eraseCookie('isCheckIn')
    eraseCookie('isDirector')
    eraseCookie('isTech')
    eraseCookie('user_roles')
    eraseCookie('expires_date')
  },
  updateAfterLogin: (state, credentials) => {
    const expires = credentials.expires_in
    const expiresDate = moment(credentials['.expires']).toISOString()
    setCookie('accessToken', credentials.access_token, expires)
    setCookie('expires_date', expiresDate, expires)
    setCookie('expires', expires, expires)
    setCookie('userName', credentials.userName, expires)

    state.accessToken = credentials.access_token
    state.expires = expires
    state.userName = credentials.userName
  },
  updateUser: (state, user) => {
    const expires = getCookie('expires')
    apis.LocationService.getById(user.Location.Id).then(res => {
      setCookie('user_location', JSON.stringify(res), expires)
      state.location = res
    })
    setCookie('user_name', user.Name, expires)
    setCookie('user_roles', user.Roles, expires)

    state.name = user.Name
    state.roles = user.Roles

    let hasRoles = !!user.Roles
    state.isAdmin = !!(hasRoles && user.Roles.includes('Administrator'))
    state.isCheckIn = !!(hasRoles && state.roles.includes('CheckIn'))
    state.isDirector = !!(hasRoles && state.roles.includes('Director'))
    state.isTech = !!(hasRoles && state.roles.includes('Tech'))

    setCookie('isAdmin', state.isAdmin, expires)
    setCookie('isCheckIn', state.isCheckIn, expires)
    setCookie('isDirector', state.isDirector, expires)
    setCookie('isTech', state.isTech, expires)
  }
}

const actions = {
  async getUserInformation ({ commit, getters }, redirectAfterSet) {
    await userService.getUserDetails().then(res => {
      if (res.status === 200) {
        commit('updateUser', res.data)

        if (redirectAfterSet) {
          router.push(getters.defaultUserPath)
        }
      }
    })
  },
  async login ({ commit, dispatch }, credentials) {
    await userService.login(credentials).then(res => {
      if (res.status === 200) {
        commit('updateAfterLogin', res.data)

        dispatch('getUserInformation', true)
      }
    })
  },
  logout ({ commit }, stayOnPage) {
    return userService.logout().then(() => {
      commit('logout')
      if (!stayOnPage) {
        router.push('/')
      }
    })
  },
  async register ({ commit, dispatch }, registerInfo) {
    // ensure user is logged out
    commit('logout')
    return userService.register(registerInfo)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
